import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Inject,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseUtilsService } from '@fuse/services/utils';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, Subject, takeUntil, tap } from 'rxjs';
import { ArticlesSeoService } from '../articles-seo.service';
import { ArticlesService } from '../articles.service';

@Component({
  selector: 'article-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DetailComponent implements AfterViewInit {
  gallery2 = [];

  // @ViewChildren(ImageComponent) photoComponents: QueryList<ImageComponent>;

  isScreenSmall: boolean;

  pagelink = '';

  public translocoSevice: any = inject(TranslocoService);
  public activeLang: string = this.translocoSevice.getActiveLang();

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private articlesService: ArticlesService,
    private _utilService: FuseUtilsService,
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private seoService: ArticlesSeoService,
  ) {
    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });

    if (isPlatformBrowser(this.platformId)) {
      this.pagelink = window.location.href;
    }
  }

  ngAfterViewInit(): void {
    // console.log(this.photoComponents.toArray());
  }

  get article$(): Observable<any> {
    return this.articlesService.article$.pipe(
      tap((article) => {
        this.seoService.setArticle(article);
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }),
    );
  }

  getResponviceClasses(widgets) {
    if (!widgets?.Columns) {
      return 'w-full col-span-1 md:col-span-12';
    }

    if (this.isScreenSmall) {
      return 'col-span-1';
    }

    const colClasses = this._utilService.generateResponsiveClass(
      widgets.Columns,
    );

    this._changeDetectorRef.markForCheck();
    return `${widgets.__component.replace('.', '_')} ${colClasses}`;
  }
  getImageUrl(image, format = 'large') {
    return (
      (format === 'full'
        ? image?.attributes?.url
        : `${image?.attributes?.formats[format]?.url}`) || ''
    );
  }
}
